import PatientTransferKeys from '../../account/sidebar/patient-transfer/patient-transfer-keys';
import dialogs from '../../modules/dialogs';

export default angular
  .module('doxy.common.logOutFactory', [])
  .factory(
    'logOutFactory',
    function (
      $state,
      $window,
      $q,
      User,
      pn,
      FirebaseMessaging,
      VideoProviderFactory,
      Auth,
      intercomFactory,
      trackingFactory,
      currentUserHelper,
      communicationControl,
      $rootScope,
      $stateParams,
      $location,
      v2
    ) {
      function cleanUp() {
        Auth.clearCurrentUser();
        pn.stop();
        VideoProviderFactory.activeProvider.stop();
        FirebaseMessaging.unsubscribe();
        trackingFactory.global.unidentifyUser();
        PatientTransferKeys.clearTransferLocalStorage();
        $rootScope.globalState.beta = {};
      }

      function logOut() {
        intercomFactory.shutdown();

        return $q((resolve, reject) => {
          User.logout(resolve, reject);
        }).finally(() => {
          cleanUp();
        });
      }

      function logOutAndRedirect(target) {
        return logOut().finally(() => {
          $stateParams.force = true;
          const params = {
            force: $stateParams.force,
          };

          if (Boolean(v2.isSignInEnabled())) {
            params.r = $location.url();
          }

          $state.go(target, params);
          dialogs.helpers.resetDialogs();
        });
      }

      function cleanUpAndRedirect(target) {
        communicationControl.removeEveryoneOnCall();
        cleanUp();
        $stateParams.force = true;
        $state.go(target, { force: $stateParams.force });
      }

      return {
        logOut,
        logOutAndRedirect,
        cleanUp,
        cleanUpAndRedirect,
      };
    }
  ).name;
